import type { GroupType } from '../CmsGroup/types';
import { ComponentRecognizer } from '../ComponentRecognizer/ComponentRecognizer';

export const GroupOnImage = ({ paragraph }: { paragraph?: GroupType[] }) => (
  <>
    {paragraph?.map((item) => {
      const { field_alignment: alignment, field_vertical_alignment: verticalAlignment } = item;
      const styleClasses = [
        // eslint-disable-next-line no-useless-escape
        '@container pointer-events-none absolute h-full w-full [&>_div]:absolute [&>_div.\_c\_cms-group]:w-auto',
        // eslint-disable-next-line no-useless-escape
        alignment === 'left' ? '[&>_div.\_c\_cms-group]:left-0' : null,
        // eslint-disable-next-line no-useless-escape
        alignment === 'right' ? '[&>_div.\_c\_cms-group]:right-0' : null,
        alignment !== 'left' && alignment !== 'right'
          ? // eslint-disable-next-line no-useless-escape
            '[&>_div.\_c\_cms-group]:left-1/2'
          : null,
        verticalAlignment === 'center' || verticalAlignment === 'stretch'
          ? // eslint-disable-next-line no-useless-escape
            '[&>_div.\_c\_cms-group]:top-1/2'
          : null,
        verticalAlignment === 'bottom' || verticalAlignment === 'flex-end'
          ? // eslint-disable-next-line no-useless-escape
            '[&>_div.\_c\_cms-group]:bottom-0'
          : null,
        verticalAlignment &&
        !['center', 'stretch', 'bottom', 'flex-end'].includes(verticalAlignment)
          ? // eslint-disable-next-line no-useless-escape
            '[&>_div.\_c\_cms-group]:top-0'
          : null,
        alignment && !['left', 'right'].includes(alignment)
          ? // eslint-disable-next-line no-useless-escape
            '[&>_div.\_c\_cms-group]:-translate-x-1/2'
          : null,
        verticalAlignment && ['center', 'stretch'].includes(verticalAlignment)
          ? // eslint-disable-next-line no-useless-escape
            '[&>_div.\_c\_cms-group]:-translate-y-1/2'
          : null,
      ];
      return (
        <span className={styleClasses.join(' ').trim()} key={item.id}>
          <ComponentRecognizer item={item} />
        </span>
      );
    })}
  </>
);
